import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";

export default class SymbolCrown extends Symbol{
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        this.texture = PIXI.Texture.from("symbol_Crown_particle.png");
        this.length = 1050;
    }

    animate(symbol, loop) {
        this.hideSymbol(symbol);
        return new Promise (res => {
            this.start(symbol).then((values) => { // duration - 1050ms
                let bg = values[0];
                let flares = values[1];
                let shine = values[2];
                this.loopShine(loop, shine).then((shine) => { // duration - 500ms * i
                    this.hideBg(bg, flares);
                    this.end(symbol, shine).then(() => res()); // duration - 250ms
                });
            })
        }).then(() => {
            this.clearEmitters();
        });
    }

    start(symbol) {
        return new Promise (res => {
            let promises = [];
            promises.push(this.background(symbol));
            promises.push(this.flares(symbol));
            promises.push(this.startShine(symbol));
            promises.push(this.startParticles(symbol));
            promises.push(this.overlay(symbol));

            Promise.all(promises).then((values) => {
                res(values);
            });
        });
    }

    startShine(symbol) {
        return new Promise(res => {
            let shine = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Crown_shine.png");
            shine.tint = 0xEEEEEE;
            this.layer.addChild(shine);

            createjs.Tween.get(shine.scale)
                .to({x: 0.95, y: 0.95}, 200 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 200 * this.speed, createjs.Ease.linear)
                .wait(200 * this.speed)
                .to({x: 1.05, y: 1.05}, 300 * this.speed, createjs.Ease.quadOut)
                .to({x: 1.025, y: 1.025}, 400 * this.speed, createjs.Ease.linear)
                .to({x: 1.05, y: 1.05}, 300 * this.speed, createjs.Ease.quadOut)
                .call(() => {
                    SymbolAnim.removeTween(shine.scale);
                    res(shine);
                });
        });
    }

    loopShine(i,shine) {
        return new Promise(res => {
            if (i === 0) {
                res(shine);
            } else {
                createjs.Tween.get(shine.scale,{loop:true})
                    .to({x: 1.025, y: 1.025}, 300 * this.speed, createjs.Ease.linear)
                    .to({x: 1.05, y: 1.05}, 200 * this.speed, createjs.Ease.quadOut)
                    .call(() => {
                        if (--i < 1) {
                            SymbolAnim.removeTween(shine.scale);
                            res(shine);
                        }
                    });

            }
        })
    }

    overlay(symbol) {
        return new Promise(res => {
            let overlay = SymbolAnim.createSprite(symbol.x, symbol.y, symbol.name+"_overlay.png");
            overlay.alpha = 0;
            overlay.scale = 1;
            overlay.blendMode = PIXI.BLEND_MODES.ADD;
            this.layer.addChild(overlay);

            // dlzka 750ms
            createjs.Tween.get(overlay.scale)
                .wait(300*this.speed)
                .to({x: 1.05, y: 1.05}, 100 * this.speed, createjs.Ease.cubicInOut)
                .wait(200 * this.speed)
                .to({x: 1.05, y: 1.05}, 300 * this.speed, createjs.Ease.quadOut)
                .to({x: 1.025, y: 1.025}, 300 * this.speed, createjs.Ease.cubicInOut)
                .to({x: 1.05, y: 1.05}, 200 * this.speed, createjs.Ease.cubicInOut)
                .call(() => {
                    SymbolAnim.removeTween(overlay.scale);
                });

            // dlzka 1050ms
            createjs.Tween.get(overlay)
                //.wait(200*this.speed)
                .to({alpha: 0.75}, 500*this.speed, createjs.Ease.circIn)
                //.wait(100*this.speed)
                .to({alpha: 0}, 200*this.speed, createjs.Ease.linear)
                .call(() => {
                    SymbolAnim.removeTween(overlay);
                    res();
                });
        });
    }

    background(symbol) {
        return new Promise(res => {
            let bg = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Crown_background.png");
            bg.alpha = 0;
            this.layer.addChild(bg);

            createjs.Tween.get(bg)
                .wait(50*this.speed)
                .to({alpha: 1}, 150*this.speed, createjs.Ease.quadOut)
                .call(() => {SymbolAnim.removeTween(bg)});

            pixiSetTimeout((this.length / 1000) * this.speed, () => {
                res(bg);
            });
        })
    }

    flares(symbol) {
        return new Promise(res => {
            let flares = SymbolAnim.createSprite(symbol.x, symbol.y, "symbol_Crown_flares.png", {x: 0.5, y: 0.48});
            flares.alpha = 0;

            this.layer.addChild(flares);
            createjs.Tween.get(flares)
                .wait(50 * this.speed)
                .to({alpha: 1}, 50 * this.speed, createjs.Ease.quadOut);

            createjs.Tween.get(flares, {loop: true})
                .to({rotation: 10*3.14}, 10*1000* this.speed, createjs.Ease.linear);

            pixiSetTimeout((this.length / 1000) * this.speed, () => {
                res(flares);
            });
        });
    }

    startParticles(symbol) {
        return new Promise(res => {
            let pos = [
                {x: symbol.x+65,y: symbol.y+10},
                {x: symbol.x-65, y: symbol.y+10},
                {x: symbol.x, y: symbol.y-50}
            ];
            createjs.Tween.get()
                .wait(1200*this.speed)
                .call(() => {
                    this.createSpark(pos[0].x, pos[0].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pos[0].x, pos[0].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    this.createSpark(pos[1].x, pos[1].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pos[1].x, pos[1].y));
                })
                .wait(300*this.speed)
                .call(() => {
                    this.createSpark(pos[2].x, pos[2].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pos[2].x, pos[2].y));
                })
                .call(() => {
                    res();
                });

        })
    }

    end(symbol, shine) {
        return new Promise (res => {
            this.endShine(shine, symbol, res);
        });
    }

    endShine (shine, symbol, callback = () => {}) {
        createjs.Tween.get(shine)
            .wait(350* this.speed)
            .call(() => {
                this.showSymbol(symbol);
            })
            .to({alpha: 0}, 100 * this.speed, createjs.Ease.quadOut)
            .call(() => {
                SymbolAnim.removeTween(shine);
            });
        SymbolAnim.removeTween(shine.scale);
        createjs.Tween.get(shine.scale)
            .to({x: 0.95, y: 0.95}, 100 * this.speed, createjs.Ease.quadOut)
            .to({x: 1, y: 1}, 350 * this.speed, createjs.Ease.quadOut)
            .call(() => {
                SymbolAnim.removeTween(shine.scale);
                callback();
            });
    }

    hideBg(bg, flares) {
        createjs.Tween.get(bg)
            .wait(150*this.speed)
            .to({alpha: 0}, 150 *this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(bg);
            });
        createjs.Tween.get(flares)
            .wait(150*this.speed)
            .to({alpha: 0}, 150 *this.speed, createjs.Ease.linear)
            .call(() => {
                SymbolAnim.removeTween(flares);
            });
    }
}